import FormValidation from './form-validation';
import { messageBoxSuccess, messageBoxError } from './message-box';

class RoomlePopupRequestPrice {
  public popup: HTMLElement | null;

  public form: HTMLFormElement | null;

  public createAccountCheckbox: HTMLInputElement | null | undefined;

  public createAccountFields: HTMLElement | null | undefined;

  public user: any;

  public inputCompany: HTMLInputElement | null | undefined;
  public buttonTabs: NodeListOf<HTMLButtonElement> | null | undefined;
  public tabColumn: HTMLElement | null | undefined;

  private requestFormValidation: FormValidation;

  private apiBaseUrl: string | undefined;

  async sendMail() {
    if (this.form) {
      const endpoint = this.form.action;
      const configurationEntryId = (this.form.querySelector('button[type="submit"]') as HTMLElement)?.dataset.entryId;
      const configurationCurrency = (this.form.querySelector('button[type="submit"]') as HTMLElement)?.dataset.currency;
      const configurationPrice = (this.form.querySelector('button[type="submit"]') as HTMLElement)?.dataset.price;
      const data = new FormData(this.form);
      data.append('configuration_id', configurationEntryId ? configurationEntryId : '');

      try {
        const res = await fetch(endpoint, {
          method: 'post',
          body: data,
        });
        const jsonRes = await res.json();

        if (jsonRes.success == true || jsonRes.success === 'true') {
          messageBoxSuccess({
            contentDe: 'E-Mail wurde erfolgreich gesendet.',
            contentEn: 'Successfully sent e-mail.',
          });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ lead: null });
          window.dataLayer.push({
            event: 'generate_lead',
            lead: {
              type: 'form_configuration',
              email: data.get('email'),
              currency: configurationCurrency === '€' ? 'EUR' : (configurationCurrency === 'CHF' ? 'CHF' : 'USD'),
              value: configurationPrice,
              content_type: 'product',
              new_lead: jsonRes.hasOwnProperty('is_first_contact') && jsonRes.is_first_contact ? 'Yes' : 'No'
            }
          });

          this.form?.classList.add('success');
          this.popup?.querySelector('.m-popup__modal-modules')?.classList.add('hidden');

          window.addEventListener('popup:close', () => {
            if (document.body.classList.contains('roomle-iframe--is-first')) {
              window.scrollTo(0, 0);
            }
            setTimeout(() => {
              this.form?.classList.remove('success');
              this.popup?.querySelector('.m-popup__modal-modules')?.classList.remove('hidden');
            }, 200);
          }, {once: true})
        } else {
          throw new Error(JSON.stringify(jsonRes.errors));
        }
      } catch(error) {
        console.error(error);

        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. E-Mail konnte nicht gesendet werden.',
          contentEn: 'An error appeared. Could not send e-mail.',
        });
      }
    }
  }

  async createAccount(): Promise<any> {
    const data = new FormData();

    // @ts-ignore
    data.append(window.csrfTokenName, window.csrfTokenValue);
    data.append('action', 'users/save-user');

    let salutation = this.form?.querySelector('select[name="salutation"]');
    if (salutation instanceof HTMLSelectElement) {
      data.append('fields[salutation]', salutation.value);
      data.append('address[fields][addressTitle]', salutation.value);
    }

    let fullName = '';
    let firstName = this.form?.querySelector('input[name="firstName"]');
    if (firstName instanceof HTMLInputElement) {
      data.append('firstName', firstName.value);
      data.append('fields[firstName]', firstName.value);
      data.append('address[firstName]', firstName.value);
      fullName = firstName.value;
    }

    let lastName = this.form?.querySelector('input[name="lastName"]');
    if (lastName instanceof HTMLInputElement) {
      data.append('lastName', lastName.value);
      data.append('fields[lastName]', lastName.value);
      data.append('address[lastName]', lastName.value);
      fullName = fullName + ' ' + lastName.value;
    }

    data.append('fullName', fullName);
    data.append('fields[fullName]', fullName);
    data.append('address[fullName]', fullName);

    let email = this.form?.querySelector('input[name="email"]');
    if (email instanceof HTMLInputElement) {
      data.append('email', email.value);
      data.append('fields[email]', email.value);
    }

    let phone = this.form?.querySelector('input[name="phoneNumber"]');
    if (phone instanceof HTMLInputElement) {
      data.append('fields[phone]', phone.value);
      data.append('address[fields][phoneNumber]', phone.value);
    }

    let organization = this.form?.querySelector('input[name="organization"]');
    let company = this.form?.querySelector('input[name="company"]');
    if (organization instanceof HTMLInputElement) {
      data.append('fields[companyName]', organization.value);
      data.append('address[organization]', organization.value);
    }
    else if (company instanceof HTMLInputElement) {
      data.append('fields[companyName]', company.value);
      data.append('address[organization]', company.value);
    }

    let postalCode = this.form?.querySelector('input[name="postalCode"]');
    if (postalCode instanceof HTMLInputElement) {
      data.append('address[postalCode]', postalCode.value);
    }

    let locality = this.form?.querySelector('input[name="locality"]');
    if (locality instanceof HTMLInputElement) {
      data.append('address[locality]', locality.value);
    }

    let street = this.form?.querySelector('input[name="street"]');
    if (street instanceof HTMLInputElement) {
      data.append('address[addressLine1]', street.value);
    }

    let notes = this.form?.querySelector('input[name="addressNotes"]');
    if (notes instanceof HTMLInputElement) {
      data.append('address[fields][addressNotes]', notes.value);
    }

    let country = this.form?.querySelector('select[name="country"]');
    if (country instanceof HTMLSelectElement) {
      data.append('address[countryCode]', country.value);
    }

    let password = this.form?.querySelector('input[name="password"]');
    if (password instanceof HTMLInputElement) {
      data.append('password', password.value);
    }

    let success = false;
    fetch(this.apiBaseUrl!, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
      },
      body: data,
    })
      .then(res => res.json())
      .then((res) => {
        if (res.id && res.id != "") {
          success = true;
          messageBoxSuccess({
            contentDe: 'Account erfolgreich angelegt. Bitte überprüfe dein E-Mail-Postfach.',
            contentEn: 'Account successfully created. Please check your email inbox.',
          });

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'sign_up',
            user: {
              email: data.get('email')
            }
          });

          return res;
        } else {
          throw new Error(JSON.stringify(res.errors));
        }
      })
      .catch((error) => {
        let errorObj = JSON.parse(error.message);

        if (errorObj.email) {
          messageBoxError({
            contentDe: errorObj.email[0],
            contentEn: errorObj.email[0],
          });
        }
        else {
          messageBoxError({
            contentDe: 'Account konnte nicht angelegt werden',
            contentEn: 'Account could not be created',
          });
        }
      });

      return success;
  }

  async handleSubmit() {
    const button = this.form?.querySelector('.js-submit-button') as HTMLButtonElement;

    button.disabled = true;
    button.classList.add('loading');

    if (this.user.email) {
      await this.sendMail();
      button.disabled = false;
      button.classList.remove('loading');
      return;
    }

    let createAccount = false;
    const createAccountField = this.form?.querySelector('input[name="create_account"]') as HTMLInputElement;
    if (createAccountField && createAccountField.checked) {
      const password = this.form?.querySelector('input[name="password"]') as HTMLInputElement;
      const passwordRepeat = this.form?.querySelector('input[name="password-repeat"]') as HTMLInputElement;

      if (password.value === passwordRepeat.value && password.value !== '') {
        createAccount = true;
      } else {
        messageBoxError({
          contentDe: 'Es ist ein Fehler aufgetreten. Bitte überprüfe Deine Passwörter.',
          contentEn: 'An error appeared. Please check your passwords.',
        });

        password.classList.add('has-error');
        passwordRepeat.classList.add('has-error');
        password.addEventListener('keydown', () => password.classList.remove('has-error'));
        passwordRepeat.addEventListener('keydown', () => passwordRepeat.classList.remove('has-error'));

        button.disabled = false;
        button.classList.remove('loading');

        return;
      }
    }

    if (this.form?.reportValidity()) {
      let res = {
        success: true,
      };

      if (createAccount) {
        res = await this.createAccount();
      }

      if (res.success) {
        await this.sendMail();
      }

      button.disabled = false;
      button.classList.remove('loading');
    }
  }

  toggleCreateAccount() {
    this.createAccountFields?.classList.toggle('d-none');
  }

  private toggleInputCompany(e: MouseEvent, isActive: boolean) {
    const { buttonTabs, tabColumn, inputCompany } = this;
    const tabColumnNeighbor = tabColumn ? tabColumn.nextElementSibling : null;
    if(buttonTabs && tabColumnNeighbor && tabColumn && inputCompany) {
      buttonTabs.forEach( (buttonTab) => buttonTab.classList.remove('is--active'));
      (e.target as HTMLElement).classList.add('is--active');

      inputCompany.value = '';
      if (isActive) {
        inputCompany.setAttribute('required', '');
        tabColumn.classList.remove('hidden');
        tabColumnNeighbor?.classList.add('col-md-offset-2');
      } else {
        inputCompany.removeAttribute('required');
        tabColumn.classList.add('hidden');
        tabColumnNeighbor?.classList.remove('col-md-offset-2');
      }
    }
  }

  bindings() {
    // if (this.form) {
    //   this.form.addEventListener('submit', this.handleSubmit.bind(this));
    // }

    if (this.createAccountCheckbox) {
      this.createAccountCheckbox.addEventListener('change', this.toggleCreateAccount.bind(this));
    }

    if(this.buttonTabs) {
      this.buttonTabs[0].addEventListener('click', (e) => this.toggleInputCompany(e, false));
      this.buttonTabs[1].addEventListener('click', (e) => this.toggleInputCompany(e, true));
    }

    if (this.form) {

      this.requestFormValidation = new FormValidation(
        this.form,
        this.handleSubmit.bind(this)
      );
      this.requestFormValidation.init();
    }

  }

  cache() {
    this.popup = document.getElementById('roomle-popup-request-price');
    this.form = this.popup?.querySelector('form') || null;
    this.createAccountCheckbox = this.form?.querySelector('input[name="create_account"]');
    this.createAccountFields = this.form?.querySelector('.js-roomle-popup-request-price-password-container');
    this.user = JSON.parse(this.popup?.querySelector('.js-current-user')?.innerHTML || '{}');
    this.buttonTabs = this.popup?.querySelectorAll('.js-form-tab-switch');
    this.tabColumn = this.popup?.querySelector('[data-key="company"]');
    this.inputCompany = this.form?.querySelector('input[name="company"]');
    this.apiBaseUrl = document.body.dataset.apiBaseUrl;
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default RoomlePopupRequestPrice;
